// SpendingSummaryPanel.jsx
import React from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts/core";
import { PieChart } from "echarts/charts";
import { TitleComponent, TooltipComponent, LegendComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import { useTheme } from "../contexts/ThemeContext";

// register the minimal set of ECharts modules
echarts.use([PieChart, TitleComponent, TooltipComponent, LegendComponent, CanvasRenderer]);

/**
 * @param {{
 *   channels: {
 *     channel: string,
 *     total_spend: number,
 *     percentage: number,
 *     formatted_spend: string
 *   }[],
 *   total_spend: number,
 *   description: string
 * }} data
 */
export default function SpendingSummaryPanel({ data }) {

    const { theme } = useTheme();
    const isDark = theme === 'dark';
    const axisColor = isDark ? '#ccc' : '#333';

    if (!data || !data.channels?.length) return null;
    console.log('aaa', data);

    const filteredChannels = data.channels.filter(
        (item) => item.channel !== "Google_SEM"
    );


    // ECharts option — no mapping!
    const option = {
        title: {
            text: "Top Spending Channels",
            left: "center",
            textStyle: { color: axisColor },
        },
        tooltip: {
            trigger: "item",
            formatter: ({ data, percent }) =>
                `${data.channel}<br/>Spend: <b>${data.formatted_spend}</b><br/>Share: <b>${percent}%</b>`,
        },
        legend: {
            orient: "vertical",
            left: "left",
            top: "middle",
            textStyle: { color: axisColor },
            formatter: ({ channel }) => {
                const item = data.channels.find((c) => c.channel === channel);
                return item ? `${item.channel} • ${item.percentage}%` : channel;
            },
        },
        // hand raw array to a dataset
        dataset: {
            //source: data.channels,
            source: filteredChannels,

        },
        series: [
            {
                type: "pie",
                radius: "55%",
                center: ["50%", "50%"],
                roseType: "radius",
                // tell ECharts which fields to use
                encode: {
                    itemName: "channel",   // slice name
                    value: "total_spend",  // slice size
                },
                label: {
                    textStyle: { color: axisColor },
                    formatter: ({ data, percent }) =>
                        `{name|${data.channel}}\n{value|${data.formatted_spend}} ({percent|${percent}%})`,
                    rich: {
                        name: { fontSize: 14, fontWeight: 600, lineHeight: 20 },
                        value: { fontSize: 12, color: "#666" },
                        percent: { fontSize: 12, color: "#999" },
                    },
                },
                labelLine: {
                    length: 20,
                    length2: 10,
                },
            },
        ],
    };

    return (
        <div className="flex flex-col md:flex-row shadow-lg rounded-xl overflow-hidden">

            <div className=" w-full p-4">
                <ReactECharts option={option} style={{ height: 600 }} />
            </div>
        </div>
    );
}
